<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>轮播图管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/banner_list')">轮播图列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label="展示状态">
            <el-select
              v-model="filters.isShow"
              placeholder="请选择"
            >
              <el-option
                label="显示"
                value="1"
              ></el-option>
              <el-option
                label="不显示"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('10011991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <el-table
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column label="轮播图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.pic"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="roleTypeNames"
            label="角色权限"
          >
          </el-table-column>
          <el-table-column
            prop="infoType"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.infoType == 1">商品</span>
              <span v-if="scope.row.infoType == 2">文章</span>
              <span v-if="scope.row.infoType == 3">图片</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="openType"
            label="弹出类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.openType == 1">轮播图</span>
              <span v-if="scope.row.openType == 2">弹窗</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="goodName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            prop="isShow"
            label="展示状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.isShow == 1"
                type="success"
                disable-transitions
              >显示</el-tag>
              <el-tag
                v-if="scope.row.isShow == 0"
                type="info"
                disable-transitions
              >不显示</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button v-if="hasPower('10011991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button v-if="hasPower('10011991')"
                @click="upHouseStatus(scope.row)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="修改轮播图"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
      >

        <el-form-item
          label="轮播图片"
          prop="pic"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :data='tokenData'
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.pic"
              :src="form.pic"
              class="avatar"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
            >只能上传jpg/png文件，图片比例：375px*210px</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="链接类型">
          <el-select
            v-model="form.info_type"
            placeholder="请选择"
          >
            <el-option
              v-for="option in typeOptions"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商品ID"
          prop='info_id'
          v-if="form.info_type == 1"
        >
          <el-input v-model="form.info_id"></el-input>
        </el-form-item>
        <el-form-item label="显示状态">
          <el-select
            v-model="form.isShow"
            placeholder="请选择"
          >
            <el-option
              v-for="option in options"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增轮播图"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        ref="form"
        size='small'
        :model="form"
        :rules="addFormRule"
      >


        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "Banner",
  created() {},
  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        pic: [{ required: true, message: "请上传轮播图片", trigger: "blur" }],
        // info_type: [
        //   { required: true, message: "请选择链接类型", trigger: "blur" }
        // ],
        info_id: [
          { required: true, message: "请输入链接对象id", trigger: "blur" }
        ],
        isShow: [{ required: true, message: "请选择是否展示", trigger: "blur" }]
      },
      addLoading: false,
      form: {
        isShow: null,
        pic: null,
        info_type: '1',
        info_id: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        isShow: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "显示", value: "1" }, { text: "不显示", value: "0" }],
      typeOptions: [{ text: "商品", value: "1" },{ text: "文章", value: "2" },{ text: "图片", value: "3" }],
      tableData: [],
      total_num: 0,
      total_page: 0,
      tableHeight:null,
      page_size: 10
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          para.place_type = 1;
          that.addLoading = true;
          API.banner_add(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });

                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.dialogAddVisible = false;
                that.addLoading = false;
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPost() {
      this.addLoading = true;
      var that = this;
      let para = Object.assign({}, that.form);
      para.token = localStorage.getItem("api_token");
      para.place_type = 1;
      API.banner_add(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    addPostDialog() {
      // this.form.pic = null;
      // this.form.info_type = '1';
      // this.dialogAddVisible = true;
      var that = this;
      that.$router.push('/addBanner');
    },
    editPostDialog(row) {
      var that = this;
      this.$router.push({ path: "/addBanner", query: { good: row } });
    },
    formatterStatus(row, column) {
      if (row.infoType == 1) {
        return "直播";
      } else if (row.infoType == 2) {
        return "活动";
      } else if (row.infoType == 3) {
        return "房产";
      } else if (row.infoType == 4) {
        return "文章";
      }
    },
    upHouseStatus(row, status) {
      let that = this;
      this.$confirm("确定删除该轮播图吗?", "提示", { type: "info" })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: 2
          };
          API.banner_delete(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token"),
        place_type: 1
      };
      if (that.filters.isShow) {
        params.isShow = that.filters.isShow;
      }
      that.loading = true;
      API.banner_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // roleTypeNames
                result.result.list.forEach(items => {
                  if (items.openType && items.openType == 2)
                  {
                    let roles = (items.roleType && items.roleType != null) ? items.roleType.split(',') : [];
                    if (roles.length > 0)
                    {
                      let roleTypeNames = [];
                      roles.forEach(items => {
                        if (items && items != null && items != '')
                        {
                          roleTypeNames.push(that.formatterRoleType({role_type:items}))
                        }
                      });
                      items.roleTypeNames = roleTypeNames.join(',')
                    }
                    else {
                      items.roleTypeNames = '';
                    }
                  } else {
                    items.roleTypeNames = '';
                  }
                });
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    formatterRoleType(row) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员 ";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word =  "康减系列市代";
      } else if (row.role_type == 2.1) {
        word =  "康减系列省代";
      } else if (row.role_type == 3.1) {
        word =  "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
       else if (row.role_type == 5) {
        return "总经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue